import React, { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { toast } from 'react-toastify';

const PaymentConfirmationModal = ({ isOpen, onClose, transaction, onConfirm }) => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [exceptionAmount, setExceptionAmount] = useState('0');
  const userDebt = transaction?.user?.user_debt || 0;
  const transactionAmount = parseFloat(transaction?.amount || 0);

  const handleConfirmPayment = async (isDebt) => {
    if (!transaction) return;
    try {
      setIsProcessing(true);
      const exception = parseFloat(exceptionAmount) || 0;
      
      if (exception > transactionAmount) {
        toast.error('مبلغ الاستثناء لا يمكن أن يتجاوز مبلغ المعاملة');
        return;
      }



      await onConfirm({
        status: 'paid',
        is_debt: isDebt,
        exception_amount: exception.toFixed(2),
        amount: transactionAmount.toFixed(2)
      });
      
      onClose();
    } catch (error) {
      toast.error(error.message || 'حدث خطأ أثناء معالجة الطلب');
    } finally {
      setIsProcessing(false);
    }
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 bg-black/70 backdrop-blur-lg z-[60]" onClick={onClose} />
      <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-md bg-gray-900 rounded-xl p-6 shadow-2xl z-[60] border border-gray-800" dir="rtl">
        <div className="mb-6">
          <h2 className="text-xl font-bold text-white">تأكيد الدفع</h2>
        </div>
        
        <div className="space-y-4">
          {userDebt > 0 && (
            <div className="bg-yellow-500/10 text-yellow-500 p-3 rounded-lg text-sm">
              المستخدم لديه مديونية بقيمة: ${userDebt.toFixed(2)}
            </div>
          )}
          
          <div className="space-y-2">
            <label className="text-sm text-gray-400">(مبلغ الاستثناء) الرصيد المضاف لليوزر</label>
            <input
              type="number"
              min="0"
              max={transactionAmount}
              value={exceptionAmount}
              onChange={(e) => setExceptionAmount(e.target.value)}
              className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-yellow-500/50"
              placeholder="0.00"
            />
          </div>

          <div className="flex gap-3 justify-end">
            <button
              onClick={() => handleConfirmPayment(false)}
              disabled={isProcessing}
              className="px-4 py-2 bg-green-500/20 text-green-500 hover:bg-green-500/30 rounded-lg transition-all flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isProcessing && <Loader2 className="w-4 h-4 animate-spin" />}
              قبول كمدفوعة
            </button>
            
            <button
              onClick={() => handleConfirmPayment(true)}
              disabled={isProcessing}
              className="px-4 py-2 bg-yellow-500/20 text-yellow-500 hover:bg-yellow-500/30 rounded-lg transition-all flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isProcessing && <Loader2 className="w-4 h-4 animate-spin" />}
              قبول كمديونية
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentConfirmationModal;